/** Where R2 media is served in production (the bucket's custom domain). */
export const PROD_MEDIA_BASE = 'https://media.obsessionstudio.co';

/**
 * Media base of this build: `VITE_MEDIA_BASE_URL` when set, else media.obsessionstudio.co in production and the
 * Worker's /media route in development. A production build that fell back to /media got 404s for every image (backlog
 * §19). Written inline on the env fields so the build folds it to one literal and ships no /media fallback.
 */
const BUILD_MEDIA_BASE: string = import.meta.env.VITE_MEDIA_BASE_URL || (import.meta.env.PROD ? PROD_MEDIA_BASE : '/media');

/** Public URL of an R2 media key. */
export function mediaUrl(key: string, base: string = BUILD_MEDIA_BASE): string {
  return `${base.replace(/\/+$/, '')}/${key.replace(/^\/+/, '')}`;
}
